import * as React from "react"
import Layout from "../components/layout"
import PageLinks from "../components/pageLinks"
import Footer from "../components/footer"
import Carousel from "../components/Carousel" 
import Introduction from "../components/introduction" 
import Specialties from "../components/specialties"
import CTA from "../components/cta"
import SEO from "../components/seo"
import { graphql } from "gatsby" 

class IndexPage extends React.Component {
  showCursor(e) {
    var title = e.currentTarget.getAttribute('data-cursor');
    if(title) {
      document.querySelector('.floating--cursor .caption .inner').innerHTML = title;
    }
    document.querySelector('.floating--cursor').classList.add('active');
  }
  hideCursor() {
    document.querySelector('.floating--cursor').classList.remove('active');
    document.querySelector('.floating--cursor').classList.remove('active-drag');
  } 
	render() {
		const { data } = this.props
    return ( 
		  <Layout classes="is-homepage" background="#DABAB4" title="home" about={data.allDatoCmsPageNavigation.edges[0].node.aboutImage.gatsbyImageData} contact={data.allDatoCmsPageNavigation.edges[0].node.contactImage.gatsbyImageData} approach={data.allDatoCmsPageNavigation.edges[0].node.approachImage.gatsbyImageData} films={data.allDatoCmsPageNavigation.edges[0].node.filmsImage.gatsbyImageData} folio={data.allDatoCmsPageNavigation.edges[0].node.folioImage.gatsbyImageData} store={data.allDatoCmsPageNavigation.edges[0].node.storeImage.gatsbyImageData} location="home">
		   	
        <SEO title="Stem Design" /> 

        <Introduction image={data.allDatoCmsHome.edges[0].node.heroMobileImage.gatsbyImageData} introduction={data.allDatoCmsHome.edges[0].node.introductionText}></Introduction> 
        
        <div className="spacer m-spacer"></div>

        <div role="presentation" onMouseEnter={this.showCursor} data-cursor="Explore" onFocus={this.showCursor} onBlur={this.hideCursor} onMouseLeave={this.hideCursor}>
          <PageLinks />
        </div>

        <div className="spacer m-spacer"></div>
        
        <Specialties image={data.allDatoCmsHome.edges[0].node.weddingMobileImage} video1={data.allDatoCmsHome.edges[0].node.videoUrl1} video2={data.allDatoCmsHome.edges[0].node.videoUrl2} video3={data.allDatoCmsHome.edges[0].node.videoUrl3} />

        <Carousel image1={data.allDatoCmsHome.edges[0].node.image1.gatsbyImageData} image2={data.allDatoCmsHome.edges[0].node.image2.gatsbyImageData} image3={data.allDatoCmsHome.edges[0].node.image3.gatsbyImageData} image4={data.allDatoCmsHome.edges[0].node.image4.gatsbyImageData} />
        
        <div className="spacer m-spacer"></div>

        <CTA />

        <Footer />

		  </Layout>
		)
	}
}
 
export default IndexPage

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allDatoCmsHome {
      edges {
        node {
          introductionText
          videoUrl
          videoUrl1
          videoUrl2
          videoUrl3
          heroMobileImage {
            gatsbyImageData(placeholder:DOMINANT_COLOR)
          }
          weddingMobileImage {
            gatsbyImageData(placeholder:DOMINANT_COLOR)
          }
          image1 {
            gatsbyImageData(placeholder:DOMINANT_COLOR)
          }
          image2 {
            gatsbyImageData(placeholder:DOMINANT_COLOR)
          }
          image3 {
            gatsbyImageData(placeholder:DOMINANT_COLOR)
          }
          image4 {
            gatsbyImageData(placeholder:DOMINANT_COLOR)
          }
        }
      }
    }
    allDatoCmsPageNavigation {
      edges {
        node {
          aboutImage {
            gatsbyImageData(placeholder:DOMINANT_COLOR)
          }
          approachImage {
            gatsbyImageData(placeholder:DOMINANT_COLOR)
          }
          filmsImage {
            gatsbyImageData(placeholder:DOMINANT_COLOR)
          }
          folioImage {
            gatsbyImageData(placeholder:DOMINANT_COLOR)
          }
          storeImage {
            gatsbyImageData(placeholder:DOMINANT_COLOR)
          }
          contactImage {
            gatsbyImageData(placeholder:DOMINANT_COLOR)
          }
        }
      }
    }
  }
`
 